import { useState } from 'react';
import { ChatFile } from '@/types/chat';
import { useChatApi } from '@/hooks/useChatApi';
import { useChatFiles as useOriginalChatFiles } from '@/hooks/useChatFiles';
import { ChatApiService } from '@/services/chatApiService';

export function useChatFiles({
    userId,
    chatApiService,
}: {
    userId: string | null;
    chatApiService: ChatApiService;
}) {
    const chatApi = useChatApi(chatApiService);
    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [selectedFiles, setSelectedFiles] = useState<ChatFile[]>([]);

    const {
        handleFileSelect,
        handleFileDrop,
        removeFile,
    } = useOriginalChatFiles({
        userId,
        selectedFiles,
        setSelectedFiles,
        setIsUploading,
        chatApi,
        captionFile: chatApi.captionFile,
    });

    return {
        isUploading,
        selectedFiles,
        setSelectedFiles,
        setIsUploading, // Also expose setter if needed by actions
        handleFileSelect,
        handleFileDrop,
        removeFile,
    };
}
